import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { catchError, of } from 'rxjs';

import { SeoMetaService, SystemPageService } from '@features/system-pages';

import { LocationService } from '../../services';

@Component({
  selector: 'app-locations-page',
  imports: [RouterModule],
  templateUrl: './locations-page.component.html',
  styleUrl: './locations-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationsPageComponent implements OnInit {
  #locationService = inject(LocationService);
  #systemPages = inject(SystemPageService);
  #seo = inject(SeoMetaService);
  #destroyRef = inject(DestroyRef);

  protected locations = toSignal(this.#locationService.list({ show_all: true }), { initialValue: [] });

  ngOnInit(): void {
    this.#systemPages
      .get('locations.index')
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        catchError(() => of(undefined)),
      )
      .subscribe((response) => {
        if (response) {
          this.#seo.apply(response);
        }
      });
  }
}
